<template>
<div>
  <vx-card>
    <div class="vx-row mb-4">
      <div class="vx-col sm:w-full w-full">
        <div class="vx-row ">
          <h5 class="flex vx-col sm:w-2/12" >관리자 페이지 코드</h5>
          <vs-input class="vx-col sm:w-8/12 w-full mb-2" placeholder="관리자 페이지 코드" value="myAdmin"/>
        </div>
        <div class="vx-row ">
          <h5 class="flex vx-col sm:w-2/12" >홈페이지명</h5>
          <vs-input class="vx-col sm:w-8/12 w-full mb-2" placeholder="홈페이지명"/>
        </div>
        <div class="vx-row ">
          <h5 class="flex vx-col sm:w-2/12" >최고관리자</h5>
          <vs-input class="vx-col sm:w-8/12 w-full mb-2" placeholder="최고관리자"/>
        </div>
        <div class="vx-row ">
          <h5 class="flex vx-col sm:w-2/12" >관리자 메일주소</h5>
          <vs-input class="vx-col sm:w-8/12 w-full mb-2" placeholder="관리자 메일주소"/>
        </div>
        <div class="vx-row ">
          <h5 class="flex vx-col sm:w-2/12" >관리자 메일 발송 이름</h5>
          <vs-input class="vx-col sm:w-8/12 w-full mb-2" placeholder="관리자 메일 발송 이름"/>
        </div>
        <div class="vx-row ">
          <h5 class="flex vx-col sm:w-2/12" >차단 IP</h5>
          <div class="vx-col sm:w-8/12 w-full">
            <textarea class="vx-col w-full" style="min-height:100px"></textarea>
          </div>
        </div>
        <div class="vx-row ">
          <h5 class="flex vx-col sm:w-2/12" >스팸 차단 단어</h5>
          <div class="vx-col sm:w-8/12 w-full">
            <textarea class="vx-col w-full" style="min-height:100px"></textarea>
          </div>
        </div>
      </div>
    </div>

    <vs-row class="w-full mt-8" vs-justify="center">
      <vs-button class="sm:w-2/12 mr-4 large" color="secondary" >저장</vs-button>
      <vs-button class="sm:w-2/12 large" color="#EDEDED" text-color="black" type="filled" >취소</vs-button>
    </vs-row>

  </vx-card>
</div>
</template>

<script>
export default {
  name: 'Basic'
}
</script>

<style scoped>
</style>
